import { useEffect, useRef, useState } from 'react';
import { s } from '../listPageStyles';
import { ColumnsIcon } from './icons';

/** Görünür kolon seçici. Props: table (TanStack table instance). */
export function ColumnChooser({ table }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const toggleableColumns = table.getAllLeafColumns().filter((col) => col.getCanHide());

  return (
    <span className="c360-chooser-wrap" ref={ref}>
      <button type="button" className="c360-chooser-btn" style={s.btnSecondary} onClick={() => setOpen((o) => !o)}>
        <ColumnsIcon /> Kolonlar
      </button>
      {open && (
        <div className="c360-chooser-popover" role="dialog" aria-label="Görünür kolonlar">
          <div className="c360-chooser-title">Görünür Kolonlar</div>
          {toggleableColumns.map((col) => {
            const header = col.columnDef.header;
            const label = typeof header === 'string' ? header : col.id;
            return (
              <label key={col.id} className="c360-chooser-item">
                <input type="checkbox" checked={col.getIsVisible()} onChange={col.getToggleVisibilityHandler()} />
                <span>{label}</span>
              </label>
            );
          })}
          <div className="c360-chooser-actions">
            <button
              type="button"
              className="c360-chooser-link"
              onClick={() => table.toggleAllColumnsVisible(true)}
            >
              Tümünü göster
            </button>
            <button
              type="button"
              className="c360-chooser-link"
              onClick={() => toggleableColumns.forEach((c) => c.toggleVisibility(false))}
            >
              Tümünü gizle
            </button>
          </div>
        </div>
      )}
    </span>
  );
}
